import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DndDraggableDirective } from 'ngx-drag-drop';
import { DisplayListListItemModel } from 'src/app/shared/models';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, DndDraggableDirective],
    selector: 'app-playlist-edit',
    templateUrl: './playlist-edit.component.html',
    styleUrls: ['./playlist-edit.component.scss']
})
export class PlaylistEditComponent implements OnChanges {
    @Input() selectedPlaylists: Array<DisplayListListItemModel> = [];
    @Output() playlistOrderUpdated = new EventEmitter<Array<DisplayListListItemModel>>();
    @Output() removePlaylist = new EventEmitter<DisplayListListItemModel>();
    @Output() previewPlaylist = new EventEmitter<DisplayListListItemModel>();
    @Output() editPlaylist = new EventEmitter<DisplayListListItemModel>();

    playlists: Array<DisplayListListItemModel> = [];

    ngOnChanges(): void {
        this.playlists = this.selectedPlaylists;
        this.playlists.forEach((x, index) => {
            x.displayOrder = index + 1;
        });
    }

    onDragged(item: DisplayListListItemModel, list: DisplayListListItemModel[]): void {
        const index = list.indexOf(item);
        list.splice(index, 1);
        list.forEach((x, i) => { x.displayOrder = i + 1; });
        this.playlistOrderUpdated.emit(list);
    }

    onDrop(event: any, list: DisplayListListItemModel[]): void {
        list.splice(event.index, 0, event.data);
        list.forEach((x, i) => { x.displayOrder = i + 1; });
        this.playlistOrderUpdated.emit(list);
    }

    onRemove(item: DisplayListListItemModel): void {
        this.removePlaylist.emit(item);
    }

    onUrlError(item: DisplayListListItemModel): void {
        item.urlError = true;
    }
}
